import React, { FC } from 'react'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'

import { components } from '@plandi/common/src/generated'
import { useProfileDetailsStyles } from './profile-details.styles'
import { useTranslation } from '@plandi/common'

type ProfileAboutProps = {
  type: string | string[] | undefined
  profileFreelancer?: components['schemas']['ProfileSpecialistMeResource']
  profileCompany?: components['schemas']['ProfileCompanyMeResource']
  profileFactory?: components['schemas']['ProfileFactoryMeResource']
}

export const ProfileAbout: FC<ProfileAboutProps> = ({
  type,
  profileFreelancer,
  profileCompany,
  profileFactory
}) => {
  const classes = useProfileDetailsStyles()
  const { data: translate } = useTranslation()

  const renderAbout = () => {
    return (
      <>
        <Typography
          variant="subtitle1"
          color="primary"
          className={classes.title}
        >
          {type === 'freelancer'
            ? translate?.['job-site']?.['specialist-page']?.about ?? 'О себе'
            : type === 'company'
            ? translate?.['job-site']?.profile?.['about-company'] ??
              'О компании'
            : translate?.['job-site']?.['about-factory'] ?? 'О заводе'}
        </Typography>

        <div className={classes.textWrap}>
          <Typography className={classes.text} variant="body2" component="span">
            {type === 'freelancer'
              ? profileFreelancer?.aboutMe
              : type === 'company'
              ? profileCompany?.about
              : profileFactory?.about}
          </Typography>
        </div>
      </>
    )
  }

  return (
    <Card className={classes.card}>
      <CardContent>{renderAbout()}</CardContent>
    </Card>
  )
}
